import {AfterContentInit, ChangeDetectionStrategy, Component, ContentChildren, Input, QueryList} from '@angular/core';
import {NgxTabItem} from '@ngx-component-kit/cards/tab-item/tab-item.component';

@Component({
    selector: 'ngx-tabs',
    templateUrl: './tabs.component.html',
    styleUrls: ['./tabs.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    preserveWhitespaces: false
})
export class NgxTabs implements AfterContentInit {

    // Tabs.
    @ContentChildren(NgxTabItem) tabs: QueryList<NgxTabItem>;

    // Inputs.
    @Input() stretch = true;


    ngAfterContentInit() {
        // Get all active tabs.
        const activeTabs = this.tabs.filter((tab) => tab.active);

        // If there is no active tab set, activate the first tab.
        if (activeTabs.length === 0) {
            this.select(this.tabs.first);
        }
    }

    select(tab: NgxTabItem) {
        // Deactivate all tabs.
        this.tabs.toArray().forEach(tab => tab.active = false);

        // Activate the tab the user has clicked on.
        tab.active = true;
    }

}
